import { render, staticRenderFns } from "./FieldAccordion.vue?vue&type=template&id=334a0e32&"
import script from "./FieldAccordion.vue?vue&type=script&lang=ts&"
export * from "./FieldAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports